import { GetterTree, ActionTree } from 'vuex';
import { replaceInArray } from '@/utils/Array';
import { messageService } from '@/utils/MessageService';
import { PersistentStore, saveAndSync, syncOperation } from '@/utils/PersistentStore';
import vuestore, { store } from '@/store';
import { CreateTypedStoreProxy } from 'vuex-typed-store';
import { usersService } from '../services/usersService';
import { Guid } from 'guid-typescript';

export interface UsersStoreModel { }

export interface UsersStoreActions {
  setUtenti(payload: server.user): Promise<void>;
  remove(payload: server.user): Promise<void>;
}

export interface UsersStoreGetters {
  get(id: string): Promise<server.user>;
  getAll(): Promise<server.user[]>;
}

export const TABLES = { users: 'users', userInRole: 'user-in-role' };
export const UsersStore = {
  PREFIX: 'users',
  namespaced: true,
  mutations: {},
  getters: {
    get: (state) => async (id): Promise<server.user> => {
      return await PersistentStore.get(TABLES.users, id);
    },
    getAll: (state) => async (): Promise<server.user[]> => {
      const result: server.user[] = await PersistentStore.getAll<server.user>(TABLES.users) || [];
      const maxts: number = await PersistentStore.getMaxTs(TABLES.users);
      usersService.List(maxts).then(async (r) => {
        replaceInArray(r, result, (a, b) => a.id === b.id);
        await PersistentStore.set(TABLES.users, r);
      });
      return result;
    },
  } as GetterTree<UsersStoreModel, UsersStoreGetters>,

  actions: {
    async setUtenti(context, payload: server.user) {
      let operation: syncOperation = syncOperation.update;
      if (!payload.id) {
        payload.id = Guid.create().toString();
        operation = syncOperation.create;
      }
      await saveAndSync(payload, TABLES.users,
        i => operation, i => usersService.Set(i, i.id), i => usersService.Set(i, i.id),
        async (o, n, op) => {
          messageService.publish('updateMediaReference', { type: 'users', oldTypeId: o.id, newTypeId: n.id } as messages.updateMediaReference);
        })
    },
    async remove(context, payload: server.user) {
      await usersService.Remove(payload.id);
      await PersistentStore.remove(TABLES.users, payload);
    },
    async setRole(context, payload: server.userInRole) {
      const operation = payload.id > 0 ? syncOperation.update : syncOperation.create
      await saveAndSync(payload, TABLES.userInRole,
        i => operation,
        i => usersService.SetRole(i, i.userId),
        i => usersService.SetRole(i, i.userId),
        async (o, n, op) => {
          await this.getters.getAll();
        });
    },
    async removeRole(context, payload: server.userInRole) {
      await usersService.RemoveRole(payload.userId, payload.roleId);
      await PersistentStore.remove(TABLES.userInRole, payload);
      await this.getters.getAll();
    }
  } as ActionTree<UsersStoreModel, UsersStoreActions>
}

export const usersStore = CreateTypedStoreProxy<UsersStoreModel, UsersStoreActions, UsersStoreGetters>(vuestore, UsersStore.PREFIX);
